
const SELL_FLOW_START = {
  HUB: 'hub',
  EVENT: 'event',
  SEARCH: 'search',
  OTHER: 'other'
};

const REGEX_URL = {
  HUB: /[\s\S]+\/sell\/?(\?.*)?$/,
  EVENT: /[\s\S]+\/event\/\d+\/?/,
  SEARCH: /[\s\S]+\/sell\/(performerSearch\/?\?q=\w+|searchEvent\/?\?id=.*)/
};

export {SELL_FLOW_START, REGEX_URL};
